import { ROUTES } from '@router'

/**
 * Returns a map of existing review pages types and set the value true to the one corresponding to the current route.
 */
export const getRoutesCurrentState = ({ route }) =>
  Object.keys(ROUTES.REVIEWS.PAGES).reduce(
    (acc, type) => ({
      ...acc,
      [type]: ROUTES.REVIEWS.PAGES[type] === route.name,
    }),
    {},
  )
